import { getTheme } from "@clipboard-health/ui-theme";
import { ThemeProvider } from "@mui/material";
import { ModalRoute } from "@src/appV2/redesign/Navigation/ModalRoute";
import { ModalTransitionSwitch } from "@src/appV2/redesign/Navigation/ModalTransitionSwitch";
import { useRouteMatch } from "react-router-dom";

import { OpenGeoLocationBottomSheet } from "../../OpenGeoLocation/OpenGeoLocationBottomSheet";
import {
  SHIFT_DETAILS_ATTENDANCE_CONFIRMED_PATH,
  SHIFT_DETAILS_OPEN_GEOLOCATION_PATH,
  SHIFT_DETAILS_UPDATE_ETA_PATH,
} from "../path";
import { AttendanceConfirmedBottomSheet } from "./components/AttendanceConfirmedBottomSheet";
import { UpdateEtaBottomSheet } from "./components/UpdateEtaBottomSheet";

export function ShiftDetailsModalRoutes(props: { shiftId: string }) {
  const { shiftId } = props;
  const match = useRouteMatch();

  return (
    <ThemeProvider theme={getTheme()}>
      <ModalTransitionSwitch>
        <ModalRoute
          shouldReplacePathOnBack
          closeModalPath={match.url}
          path={`${match.url}${SHIFT_DETAILS_UPDATE_ETA_PATH}`}
          render={({ modalState }) => (
            <UpdateEtaBottomSheet modalState={modalState} shiftId={shiftId} />
          )}
        />

        <ModalRoute
          shouldReplacePathOnBack
          closeModalPath={match.url}
          path={`${match.url}${SHIFT_DETAILS_OPEN_GEOLOCATION_PATH}`}
          render={({ modalState }) => <OpenGeoLocationBottomSheet modalState={modalState} />}
        />

        <ModalRoute
          shouldReplacePathOnBack
          closeModalPath={match.url}
          path={`${match.url}${SHIFT_DETAILS_ATTENDANCE_CONFIRMED_PATH}`}
          render={({ modalState }) => <AttendanceConfirmedBottomSheet modalState={modalState} />}
        />
      </ModalTransitionSwitch>
    </ThemeProvider>
  );
}
